import { render, staticRenderFns } from "./video-empresa.vue?vue&type=template&id=d1948176&scoped=true"
import script from "./video-empresa.vue?vue&type=script&lang=js"
export * from "./video-empresa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1948176",
  null
  
)

export default component.exports